import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import useFetch from '../../../../components/hooks/useFetch';
import { useLocation } from 'react-router-dom';
import InputCpf from '../../../../components/form/InputCpf';
import Input from '../../../../components/form/Input';
import { yupResolver } from '@hookform/resolvers/yup';
import '../../../../assets/css/custom-toast.css';
import InputNomeCompleto from '../../../../components/form/InputNomeCompleto';
import InputCadastro from '../../../../components/form/InputCadastro';
import { ALTERAR_MEUCORREIOS_DEPENDENTE } from '../../../../services/meuCorreios';
import { useNavigate } from 'react-router-dom';
import { formSchemaAlterar } from './FormSchema';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';

const TelaAlterarDependente = () => {
  const methods = useForm({ resolver: yupResolver(formSchemaAlterar) });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const location = useLocation();
  const dados = location.state;
  const dadosDependente = dados[0];
  const ipAddress = dados[1];
  const dadosResponsavel = { idCorreios: dados[2] };
  const { request } = useFetch();
  const navigate = useNavigate();
  const handleSubmit = async (data) => {
    const dadosEnviar = {
      idCorreios: dadosDependente.idCorreios,
      nome: data.nome.trim(),
      cie: data.identidadePassaporte,
    };
    const { response } = await request(
      ALTERAR_MEUCORREIOS_DEPENDENTE(
        dadosResponsavel.idCorreios,
        dadosEnviar,
        ipAddress,
      ),
    );

    if (response.ok) {
      abreAlertaDialog('Dependente/Tutelado alterado com sucesso');
      navigate('/dependentes', { state: dadosResponsavel });
    }
  };
  return (
    <>
      <div className="conteudo">
        <div id="cadastro-pf" className="card bg-superficie elev5">
          <h1>Alterar Dependente ou tutelado</h1>

          <form id="formCadastro" onSubmit={methods.handleSubmit(handleSubmit)}>
            <InputCpf
              label="CPF"
              type="text"
              id="cpf"
              name="cpf"
              disabled="true"
              defaultValue={dadosDependente.usuarioExternoPF.cpfFormatado}
              {...formMethods}
            />
            <Input
              type="hidden"
              name="tipoEstrangeiro"
              value={dadosDependente.usuarioExternoPF.tipoEstrangeiro}
              {...formMethods}
            />
            <InputNomeCompleto
              type="text"
              id="nome"
              name="nome"
              maxLength="150"
              label="Nome / Nome social*"
              placeholder=""
              defaultValue={dadosDependente.nome}
              {...formMethods}
            />
            {dadosDependente.usuarioExternoPF.tipoEstrangeiro != 'N' ? (
              <InputCadastro
                type="text"
                id="identidadePassaporte"
                name="identidadePassaporte"
                maxLength="20"
                defaultValue={dadosDependente.usuarioExternoPF.cie}
                label="Identidade ou passaporte*"
                {...formMethods}
              />
            ) : (
              <Input
                type="hidden"
                id="identidadePassaporte"
                name="identidadePassaporte"
                {...formMethods}
              />
            )}
            <p className="legenda txt-obrigatorios">*Campos obrigatórios</p>
            <hr />
            <div className="btns-row">
              <button
                id="btn-prosseguir"
                type="submit"
                className="btn-pre primario"
              >
                Alterar
              </button>

              <button
                id="btn-voltar"
                type="button"
                className="btn-txt"
                onClick={() =>
                  navigate('/dependentes', { state: dadosResponsavel })
                }
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default TelaAlterarDependente;
